import { render, staticRenderFns } from "./PrintRanks.vue?vue&type=template&id=08e5d34c&scoped=true&"
import script from "./PrintRanks.vue?vue&type=script&lang=js&"
export * from "./PrintRanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e5d34c",
  null
  
)

export default component.exports